module.exports = __webpack_public_path__ + "img/Puerto-Rico.6ff2a743.png";